import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-array',
  templateUrl: './formly-array.component.html',
  styleUrl: './formly-array.component.scss',
})
export class FormlyArrayComponent extends FieldArrayType {}
